import { HomepageBlogItem } from 'models/homepage-blog-item';
import {Agent, request} from './base';

export class HomepageBlogAgent extends Agent<HomepageBlogItem> {
    constructor() {
        super(HomepageBlogItem, '/homepage-blog');
    }
    getItems = async () => {
        return await request.get(`/homepage-blog`);
    };
    syncAll = async () => {
        return await request.post(`/homepage-blog/sync`, {
        });
    };
}
